// extracted by mini-css-extract-plugin
module.exports = {"container":"or_container__OuRFA","dash":"or_dash__6CBwb","fade-in":"or_fade-in__v84Jy"};